import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../../api/$api";
import { TDataToken, TQueries, RoleData, AddRole, IMakeAdministratorData } from "./type";

export const updateRole = (
    data: TDataToken,
    payload: TQueries
) => {
    const queryString = Object.entries(payload)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join("&");

    return $api
        .put(`/admin/roles/update?${queryString}`, {}, { token: data.accessToken })
        .then((response) => {
            return response?.payload?.data;
        });
};

export const useUpdateRole = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, RoleData>
) => {
  return useMutation({
    mutationFn: (payload : RoleData) =>
        updateRole(data, payload),
    ...config
  });
};


export const deleteRole = (
  data: TDataToken,
  payload: TQueries
) => {
  return $api.delete(`/admin/roles/delete`, {
    params: payload,
    headers: {
      Authorization: `Bearer ${data.accessToken}`,
    },
  });
};

export const useDeleteRole = (data: TDataToken, config?: UseMutationOptions<any, unknown, RoleData>) => {
  return useMutation({
    mutationFn: (payload: RoleData) => deleteRole(data, payload),
    ...config
  });
};


export const addRole = (
  data: TDataToken,
  payload: AddRole
) => {
  return $api
    .post("/admin/groups/invite", { ...payload }, { token: data.accessToken })
    .then((response) => {
      return response;
    });
};

export const useAddNewRole = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, AddRole>
) => {
  return useMutation({
    mutationFn: (payload:AddRole) =>
      addRole(data, payload),
    ...config
  });
};


export const moveUserRole = (
  data: TDataToken,
  payload: RoleData
) => {
  return $api
      .put(`/admin/users/move-user`, { ...payload }, { token: data.accessToken })
      .then((response) => {
          return response;
      });
};

export const useMoveUserRole = (
  data: TDataToken,
  config?: UseMutationOptions<any, unknown, RoleData>
) => {
  return useMutation({
    mutationFn: (payload: RoleData) =>
      moveUserRole(data, payload),
    ...config
  });
};


export const createMakeAdministrator = (
    data: TDataToken,
    payload: IMakeAdministratorData
  ) => {
    return $api
      .post("/admin/orgs/make-admin", { ...payload }, { token: data.accessToken })
      .then((response) => {
        return response;
      });
  };
  
  export const useMakeAdministrator = (
    data: TDataToken,
    config?: UseMutationOptions<any, unknown, any>
  ) => {
    return useMutation({
      mutationFn: (payload:IMakeAdministratorData) =>
        createMakeAdministrator(data, payload),
      ...config
    });
  };